import { Box, Pressable, Text, Image, HStack } from 'native-base';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguagePicker from './LanguagePicker';
import logoImage from '../assets/logo_image.png';
import logoA2A56 from '../assets/A2A56LE.png';

interface Props {
  upper: boolean;
}
const Navbar = ({ upper }: Props) => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Box
      height="76px"
      width="70%"
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      //@ts-ignore
      position="relative"
      //@ts-ignore
      style={{ position: 'relative', zIndex: 10000, overflow: 'visible' }}>
      {/*@ts-ignore */}
      <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
        <Image
          source={{
            uri: upper ? logoImage : logoA2A56,
          }}
          alt="A2A56 Logo"
          width="135px"
          height="52px"
          resizeMode="contain"
        />
      </Link>
      <Box
        flex={1}
        height="75px"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-end"
        //@ts-ignore
        position="relative"
        //@ts-ignore
        style={{ position: 'relative', overflow: 'visible', gap: '24px' }}>
        {/*@ts-ignore */}
        <Link to="/" style={{ textDecoration: 'none' }}>
          {/*@ts-ignore */}
          <Pressable>
            {({ isHovered }) => {
              const isActive = location.pathname === '/';
              return (
                <Box
                  p={0}
                  m={0}
                  pb={1}
                  borderBottomWidth="3px"
                  borderBottomColor={
                    isActive || isHovered ? (upper ? '#ffb31c' : '#293d8b') : 'transparent'
                  }>
                  <Text
                    fontSize="17px"
                    color={
                      isActive || isHovered
                        ? upper
                          ? '#ffffff'
                          : '#ffb31c'
                        : upper
                        ? '#ffb31c'
                        : '#293d8b'
                    }
                    textAlign="center"
                    fontWeight="semibold"
                    fontFamily="Segoe UI"
                    letterSpacing={0}
                    opacity={1}>
                    {t('home')}
                  </Text>
                </Box>
              );
            }}
          </Pressable>
        </Link>

        {/*@ts-ignore */}
        <Link to="/about" style={{ textDecoration: 'none' }}>
          {/*@ts-ignore */}
          <Pressable>
            {({ isHovered }) => {
              const isActive = location.pathname === '/about';
              return (
                <Box
                  p={0}
                  m={0}
                  pb={1}
                  borderBottomWidth="3px"
                  borderBottomColor={
                    isActive || isHovered ? (upper ? '#ffb31c' : '#293d8b') : 'transparent'
                  }>
                  <Text
                    fontSize="17px"
                    color={
                      isActive || isHovered
                        ? upper
                          ? '#ffffff'
                          : '#ffb31c'
                        : upper
                        ? '#ffb31c'
                        : '#293d8b'
                    }
                    textAlign="center"
                    fontWeight="semibold"
                    fontFamily="Segoe UI"
                    letterSpacing={0}
                    opacity={1}>
                    {t('about Us')}
                  </Text>
                </Box>
              );
            }}
          </Pressable>
        </Link>

        {/*@ts-ignore */}
        <Link to="/contact" style={{ textDecoration: 'none' }}>
          {/*@ts-ignore */}
          <Pressable>
            {({ isHovered }) => {
              const isActive = location.pathname === '/contact';
              return (
                <Box
                  p={0}
                  m={0}
                  pb={1}
                  borderBottomWidth="3px"
                  borderBottomColor={
                    isActive || isHovered ? (upper ? '#ffb31c' : '#293d8b') : 'transparent'
                  }>
                  <Text
                    fontSize="17px"
                    color={
                      isActive || isHovered
                        ? upper
                          ? '#ffffff'
                          : '#ffb31c'
                        : upper
                        ? '#ffb31c'
                        : '#293d8b'
                    }
                    textAlign="center"
                    fontWeight="semibold"
                    fontFamily="Segoe UI"
                    letterSpacing={0}
                    opacity={1}>
                    {t('contact us')}
                  </Text>
                </Box>
              );
            }}
          </Pressable>
        </Link>

        {/*@ts-ignore */}
        <Link to="/help" style={{ textDecoration: 'none' }}>
          {/*@ts-ignore */}
          <Pressable>
            {({ isHovered }) => {
              const isActive = location.pathname === '/help';
              return (
                <Box
                  p={0}
                  m={0}
                  pb={1}
                  borderBottomWidth="3px"
                  borderBottomColor={
                    isActive || isHovered ? (upper ? '#ffb31c' : '#293d8b') : 'transparent'
                  }>
                  <Text
                    fontSize="17px"
                    color={
                      isActive || isHovered
                        ? upper
                          ? '#ffffff'
                          : '#ffb31c'
                        : upper
                        ? '#ffb31c'
                        : '#293d8b'
                    }
                    textAlign="center"
                    fontWeight="semibold"
                    fontFamily="Segoe UI"
                    letterSpacing={0}
                    opacity={1}>
                    {t('help')}
                  </Text>
                </Box>
              );
            }}
          </Pressable>
        </Link>

        {/*@ts-ignore */}
        <Link to="/security_policy" style={{ textDecoration: 'none' }}>
          {/*@ts-ignore */}
          <Pressable>
            {({ isHovered }) => {
              const isActive = location.pathname === '/security_policy';
              return (
                <Box
                  p={0}
                  m={0}
                  pb={1}
                  borderBottomWidth="3px"
                  borderBottomColor={
                    isActive || isHovered ? (upper ? '#ffb31c' : '#293d8b') : 'transparent'
                  }>
                  <Text
                    fontSize="17px"
                    color={
                      isActive || isHovered
                        ? upper
                          ? '#ffffff'
                          : '#ffb31c'
                        : upper
                        ? '#ffb31c'
                        : '#293d8b'
                    }
                    textAlign="center"
                    fontWeight="semibold"
                    fontFamily="Segoe UI"
                    letterSpacing={0}
                    opacity={1}>
                    {t('security policy')}
                  </Text>
                </Box>
              );
            }}
          </Pressable>
        </Link>

        {/* Bandera y nombre de Colombia */}
        <HStack
          alignItems="center"
          space={2}
          px={3}
          py={2}>
          <Image
            source={{
              uri: `${process.env.PUBLIC_URL}/icons/col.svg`,
            }}
            alt="Colombia"
            width="32px"
            height="24px"
            //@ts-ignore
            style={{
              imageRendering: 'auto',
              objectFit: 'cover',
              borderRadius: '2px'
            }}
          />
          <Text
            fontSize="17px"
            color={
              upper
                ? '#ffffff'
                : '#293d8b'
            }
            textAlign="center"
            fontWeight="semibold"
            fontFamily="Segoe UI"
            letterSpacing={0}
            opacity={1}>
            Colombia
          </Text>
        </HStack>

        {/* Espaciado adicional antes del selector de idioma */}
        <Box width="16px" />

        <LanguagePicker upper={upper} />
      </Box>
    </Box>
  );
};

export default Navbar;
